<template>
  <div class="item">
    <a :href="itemSlug">
      <div class="img">
        <img class="img-fluid" :src="item.img" />
        <span class="badge badge-pill" v-if="showBadgeText">{{item.badgeText}}</span>
      </div>
      <div class="info text-left">
        <b-badge pill v-if="showCategory">{{item.brand}}</b-badge>
        <p class="title mb-0">{{item.title}}</p>
        <p class="mb-0" v-if="item.productModelType === 1">
          {{renderPriceRangeDisplay(item)}}
        </p>
        <p class="mb-0" v-else-if="item.price != item.discount">
          {{renderDiscountPriceDisplay(item.discount)}} <del class="subcolor4">{{renderPriceDisplay(item.price)}}</del>
        </p>
        <p class="mb-0" v-else>
          {{renderPriceDisplay(item.price)}}
        </p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: ['item','showCategory','baseUrl'],
  mounted () {
    //console.log(this.item);
  },
  computed: {
    showBadgeText() {
      return this.item.badgeText !== '';
    },
    itemSlug() {
      let culture = this.$i18n.locale === "" || this.$i18n.locale === "zh-tw" ? "" : "/" + this.$i18n.locale;

      return culture + this.baseUrl + this.item.slug;
    },
    priceSign() {
      if(this.$i18n.locale === "zh-tw"){
        return "原價$";
      }else{
        return "$";
      }
    },
    discountPriceSign() {
      if(this.$i18n.locale === "zh-tw"){
        return "網路價$";
      }else{
        return "$";
      }
    }
  },
  methods: {
    renderDiscountPriceDisplay(price){
      return this.discountPriceSign + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    renderPriceRangeDisplay(item){
      //console.log(item);
      if(item.price != item.discount){
        return this.priceSign + item.discount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " ~ $" + item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
        return this.priceSign + item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    renderPriceDisplay(price){
      return this.priceSign + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
</script>
